import React, { createContext, useReducer } from "react";
import { RouteStatusReducer } from "../reducers/RouteStatusReducer";

export const RouteStatusContext = createContext();

const RouteStatusContextProvider = (props) => {
  const state = {
    totalRoutes: "0",
    routeList: [],
    alert: {},
    lastUpdated: Date.now(),
  };
  const [viewModel, dispatch] = useReducer(RouteStatusReducer, state);
  return (
    <RouteStatusContext.Provider value={{ viewModel, dispatch }}>
      {props.children}
    </RouteStatusContext.Provider>
  );
};

export default RouteStatusContextProvider;



// WEBPACK FOOTER //
// ./src/components/RouteStatus/context/RouteStatusContext.js